import { useSelector } from 'react-redux';
import React from 'react';

import useClassName from '../../../../r/hooks/class-name';
import { FeedbackWrapper } from './styled';

const Feedback = () => {
  const { feedback } = useSelector((state) => state.auth);

  const className = useClassName([
    !feedback.success ? 'error' : '',
    'feedback'
  ]);

  if (!feedback.message) return null;

  return (
    <FeedbackWrapper className={className}>
      {feedback.message}
    </FeedbackWrapper>
  );
};

export default Feedback;